import { useFrame, useThree } from '@react-three/fiber';
import { useEffect, useRef } from 'react';
import { usePerformanceStore } from '@/stores/performanceStore';

const SAMPLE_INTERVAL_MS = 500;

export function PerformanceMonitor() {
  const setPerformance = usePerformanceStore((state) => state.setPerformance);
  const pushFpsSample = usePerformanceStore((state) => state.pushFpsSample);
  const { gl } = useThree();

  // Frame counter — incremented by useFrame on every rendered frame.
  const frames = useRef(0);

  // useFrame just counts — no time checks, no state writes.
  // This keeps the hot path as cheap as possible.
  useFrame(() => {
    frames.current++;
  });

  // Wall-clock interval: fires every 500 ms regardless of whether the R3F
  // frameloop is running. This means the history keeps scrolling even when
  // the canvas is idle (e.g. a tooltip is open and blocking pointer events).
  useEffect(() => {
    let prevTime = Date.now();

    const id = setInterval(() => {
      const time = Date.now();
      const elapsed = time - prevTime;
      const fps = Math.round((frames.current * 1000) / elapsed);

      setPerformance({
        fps,
        triangles: gl.info.render.triangles,
        drawCalls: gl.info.render.calls,
      });
      pushFpsSample({ t: time, v: fps });

      prevTime = time;
      frames.current = 0;
    }, SAMPLE_INTERVAL_MS);

    return () => clearInterval(id);
    // gl is stable for the lifetime of the canvas — safe to omit from deps.
    // setPerformance and pushFpsSample are stable Zustand actions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
